import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  IAppState,
  ICriticalConfig,
  IDefferedConfig,
  IIssuedCheckFileFormats,
  IMasterSetupState,
  IPayeeMatchParameters,
  ITimeZone,
} from '../shared/models/store.model'
import { ILookupValues } from '../shared/models/lookupValues.model'

const initialState: IMasterSetupState = {
  criticalConfig: null,
  deferredConfig: null,
  lookupValues: null,
  timeZoneList: null,
  payeeMatchParameters: [],
  issuedCheckFileFormats: [],
}

const masterSetupReducer = createSlice({
  name: 'masterSetup',
  initialState,
  reducers: {
    updateCriticalConfig(state: IMasterSetupState, action: PayloadAction<ICriticalConfig>) {
      state.criticalConfig = action.payload
    },

    updateDeferredConfig(state: IMasterSetupState, action: PayloadAction<IDefferedConfig>) {
      state.deferredConfig = action.payload
    },

    updateLookupValues(state: IMasterSetupState, action: PayloadAction<ILookupValues>) {
      state.lookupValues = action.payload
    },

    updateTimeZones(state: IMasterSetupState, action: PayloadAction<ITimeZone[]>) {
      state.timeZoneList = action.payload
    },

    updatePayeeMatchParameters(state: IMasterSetupState, action: PayloadAction<IPayeeMatchParameters[]>) {
      state.payeeMatchParameters = action.payload
    },

    updateIssuedCheckFileFormats(state: IMasterSetupState, action: PayloadAction<IIssuedCheckFileFormats[]>) {
      state.issuedCheckFileFormats = action.payload
    },
  },
})

const rootState = (state: IAppState) => state.masterSetup

export const getCriticalConfig = createSelector(rootState, (state: IMasterSetupState) => state.criticalConfig)

export const getDeferredConfig = createSelector(rootState, (state: IMasterSetupState) => state.deferredConfig)

export const getLookupValues = createSelector(rootState, (state: IMasterSetupState) => state.lookupValues)

export const getTimezoneList = createSelector(rootState, (state: IMasterSetupState) => state.timeZoneList)

export const getDefaultTimeZone = createSelector(
  rootState,
  (state: IMasterSetupState) => state.deferredConfig?.systemDefaults?.defaultTimeZone,
)

export const {
  updateCriticalConfig,
  updateDeferredConfig,
  updateLookupValues,
  updateTimeZones,
  updatePayeeMatchParameters,
  updateIssuedCheckFileFormats,
} = masterSetupReducer.actions

export default masterSetupReducer